import { sanitizeMjcfName } from "./mjcfNames";

type ControlNameParams = {
  baseName?: string | null;
  jointUuid?: string | null;
  rootBodyUuid?: string | null;
  tendonName?: string | null;
};

const hashString = (input: string): string => {
  let hash = 0;
  for (let i = 0; i < input.length; i++) {
    hash = (hash * 33) ^ input.charCodeAt(i);
    hash |= 0;
  }
  return Math.abs(hash).toString(16).padStart(8, "0");
};

export function generateActuatorControlName(params: ControlNameParams): string {
  const { baseName, jointUuid, rootBodyUuid, tendonName } = params;
  const label = sanitizeMjcfName(baseName || tendonName || "actuator");
  const hashInput = [rootBodyUuid || "", jointUuid || "", tendonName || ""]
    .filter(Boolean)
    .join("|");
  if (!hashInput) {
    return label;
  }
  const suffix = hashString(hashInput);
  return sanitizeMjcfName(`${label}__${suffix}`);
}

/**
 * Most-stable actuator naming: if we have an actuator UUID, derive the MuJoCo `actuator name=""`
 * directly from it so UI<->worker control routing does not depend on joint/root hashing.
 */
export function generateStableActuatorNameFromUuid(actuatorUuid: string): string {
  return sanitizeMjcfName(`act_${actuatorUuid}`);
}
